import 'fancybox-core';
import 'imagesloaded';
import 'jquery-match-height';
import 'slick-carousel';
import 'tooltipster';

const $features = $('.product-features');
if ($features.length) {
  const self = {};

  /** Initialise the module. */
  self.initialise = function initialise() {
    if ($features.find('ul li').length > 5) {
      $('.js-expand-features').show();

      $('.js-expand-features').click(function click(e) {
        e.preventDefault();
        $features.find('ul li.feature.extra').toggleClass('show');
        $(this).toggleClass('less');
      });
    }

    $('.product-tooltip').tooltipster({ position: 'bottom' });

    $('.product-tooltip-oneplus').tooltipster({ position: 'bottom' });

    $('.product-tooltip-brushless').tooltipster({ position: 'bottom' });

    $('.product-tooltip-warranty').tooltipster({ position: 'bottom' });
  };

  self.initialise();
}
